<template>
  <section class="stores-cat mb30 cl-black">
    <div class="container p15">
      <div slot="content row ">
        <div :class="{ 'parent': !showTage }" class="relative" v-if="tags.length">
          <div v-show="tags.length > 8 " :class="{ 'hidden' : showTage, 'show-category-tags' : tags.length > 8 } "
               class="block-three-doots">
            <span class="material-icons three-dots" @click="openTag">
              more_horiz
            </span>
          </div>
          <div v-show="tags.length > 8" :class="{ 'hidden' : showTage, 'show-category-tags' : tags.length > 8 }"
               class="dimming-element"
          />
          <div class="tags" id="tags">
            <tag-chips v-for="tag in tags" :tag="tag" :key="tag.entity_id" @changeTag="changeTag" />
          </div>
        </div>
        <div>
          <div v-if="(showPartners && !getLoader && !showFilterPartners || filterPartners.length)">
            <div class="main row" infinite-wrapper>
              <partner-card v-for="(store, index) in stores" :store="store" :key="store.id" :lazy="index > 7" :seo-context="categoryAltContext" />
            </div>
            <no-ssr>
              <infinite-loading v-show="componentLoaded" ref="partners-infinite" force-use-infinite-wrapper :distance="50" @infinite="loadPartners">
                <span slot="no-more" />
                <span slot="error" />
                <span slot="no-results" />
                <span slot="spinner">
                  <bounce-loader />
                </span>
              </infinite-loading>
            </no-ssr>
          </div>
          <div class="row main" v-else-if="!showPartners && getLoader">
            <bounce-loader />
          </div>
          <div class="row main" v-else-if="showPartners">
            {{ $t('Sorry, no partners were found for your query') }}
          </div>
          <div v-if="isTagActive.length && filterPartners.length && showFilterPartners && !stores.length">
            {{ $t('Nothing was found in the selected tag for this search query') }}
          </div>
          <div class="card col-lg-3 col-md-3 col-sm-6 col-xs-6" style="display: none">
            <div class="card-wrap">
              <router-link class="no-underline parent-link" :to="doPartner.route">
                <div class="row parent center-xs">
                  <div class="img-wrap col-xs-12 middle-xs flex">
                    <img class="" src="../../../../assets/icons/famous.svg" :alt="doPartner.title" width="82" height="84" loading="lazy" fetchpriority="auto">
                  </div>
                  <span class="col-xs-12 center-xs"> {{ doPartner.about }}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script async>
import { mapGetters } from 'vuex'
import { isServer, s3Path } from '@vue-storefront/core/helpers';
import config from 'config';
import { partnersListScope } from 'src/modules/partners/helpers/listScope';
import NoSSR from 'vue-no-ssr';
const HomePartnerCard = () => import(/* webpackChunkName: "vsf-component-bounce-loader" */ 'theme/components/theme/blocks/Partners/HomePartnerCard');
const PartnerTagChips = () => import(/* webpackChunkName: "vsf-component-bounce-loader" */ 'theme/components/theme/blocks/Partners/PartnerTagChips');
const InfiniteLoading = () => import(/* webpackChunkName: "vsf-component-infinite-loading" */ 'vue-infinite-loading');
const BounceLoader = () => import(/* webpackChunkName: "vsf-component-bounce-loader" */ 'theme/components/theme/blocks/Home/Preloaders/BounceLoader');

export default {
  components: {
    'partner-card': HomePartnerCard,
    'tag-chips': PartnerTagChips,
    'no-ssr': NoSSR,
    InfiniteLoading: isServer ? { render: h => h() } : InfiniteLoading,
    BounceLoader
  },
  data (vm) {
    return {
      componentLoaded: false,
      doPartner: {
        route: '#',
        title: vm.$t('Become a partner'),
        about: vm.$t('Become a partner')
      },
      filterCode: '',
      showTage: false,
      from: 0,
      size: 12,
      isLoad: false,
      showPartners: true
    }
  },
  computed: {
    ...mapGetters({
      getPartnersByCategory: 'partners/getPartnersByCategory',
      getLoader: 'partners/getLoader',
      partners: 'partners/getPartnersByLocation',
      tags: 'partner_tags/getTags',
      selectTags: 'partner_tags/getSelectedTags',
      currentLocation: 'locations/getActiveLocation',
      isTagActive: 'partner_tags/getSelectedTags',
      getActivePartnersCategory: 'partner_categories/getActivePartnersCategory'
    }),
    showFilterPartners () {
      return this.$store.state.partners.showFilterPartners
    },
    filterPartners () {
      return this.$store.state.partners.filterPartners
    },
    filterPartnersWithActiveTag () {
      // entity_id arrives as a numeric string, partner.tags holds numbers -
      // same fix as getters.ts's filterByTags.
      const activeTagId = parseInt(this.isTagActive[0].entity_id)
      return this.filterPartners.filter(partner => {
        if (partner.tags.filter(tag => tag === activeTagId).length) {
          return partner
        }
      })
    },
    stores () {
      if (this.filterPartners && this.filterPartners.length && this.showFilterPartners) {
        return this.isTagActive.length ? this.filterPartnersWithActiveTag : this.filterPartners
      }
      if (this.$route.params.listId) {
        return this.getPartnersByCategory(this.$route.params.listId)
      }
      return this.partners
    },
    server () {
      return isServer
    },
    // Passed to partner cards so image alt text can be templated per K2-2985
    // ({restaurant} — {category} доставка {city}); null outside a category
    // page, where cards keep their plain restaurant-name alt text. Prefers
    // the selected tag (Суші) over the coarser category (Food) since the
    // tag is the real ranking/search-intent term.
    categoryAltContext () {
      if (!this.$route.params.listId || !this.currentLocation) {
        return null
      }
      if (this.selectTags && this.selectTags.length) {
        return { category: this.selectTags[0].title, city: this.currentLocation.name }
      }
      if (this.getActivePartnersCategory) {
        return { category: this.getActivePartnersCategory.title, city: this.currentLocation.name }
      }
      return null
    }
  },
  metaInfo () {
    const preloadLogos = this.partners
      .slice(0, 4)
      .map((partner) => ({
        rel: 'preload',
        as: 'image',
        href: s3Path(partner.logo_path, config.images.partner_card_logo.width, config.images.partner_card_logo.height)
      }))
    return {
      link: [...preloadLogos]
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.componentLoaded = true
    })
    this.openOrScrollTags()
    // Continue from page 2 only if the store holds page 1 of this exact list (e.g.
    // from SSR); anything else - another view's list, a single partner - is cleared.
    if (this.$store.getters['partners/getListScope'] === this.listScope() && this.partners.length) {
      this.from = this.size
    } else {
      this.from = 0
      if (this.partners.length) {
        this.$store.dispatch('partners/clearPartners')
      }
    }
    this.$bus.$on('reset-load-partners', this.resetInfinity)
  },
  methods: {
    listScope () {
      return partnersListScope({
        locationCode: this.currentLocation && this.currentLocation.code,
        categoryId: this.getActivePartnersCategory && this.getActivePartnersCategory.entity_id,
        tagId: this.isTagActive.length ? this.isTagActive[0].entity_id : null
      })
    },
    changeStore (store) {
      this.$router.push({path: store.route})
    },
    getServiceText (service, store) {
      return (service.code === 'pickup' || service.code === 'minimal_order_amount')
        ? service.title
        : `${service.title}: ${store.working_hours}`
    },
    openTag () {
      this.showTage = true;
    },
    openOrScrollTags () {
      if (this.tags.length && this.isTagActive && this.isTagActive.length) {
        let indexSelectedTag = this.tags.indexOf(this.tags.find(tag => tag.entity_id === this.isTagActive[0].entity_id && tag.code === this.isTagActive[0].code))
        let widthTagsIsShow = 0
        if (indexSelectedTag) {
          if (window && window.innerWidth >= 1024) {
            this.tags.forEach((tag, index) => {
              let widthTag = document.getElementById(`tag-${tag.code}`).offsetWidth;
              if (widthTagsIsShow + widthTag < 1154) {
                widthTagsIsShow += widthTag
              } else {
                if (indexSelectedTag >= index && !this.showTage) {
                  this.showTage = true
                }
              }
            })
          } else {
            let el = document.getElementById(`tag-${this.isTagActive[0].code}`);
            if (el) {
              el.scrollIntoView({behavior: 'smooth'})
            }
          }
        }
      }
    },
    async loadPartners ($store) {
      let store = $store || (this.$refs['partners-infinite'] && this.$refs['partners-infinite'].stateChanger)
      if (this.isLoad) {
        // A duplicate call: stateChanger.reset() (in changeTag) re-triggers
        // infinite-loading's own @infinite check ~1ms later via its internal
        // setTimeout, always losing this race against the direct loadPartners()
        // call right after reset(). infinite-loading already flipped its status
        // to LOADING before invoking us though, so bailing out without telling
        // it leaves that status stuck forever - breaking further scroll-to-load.
        if (store) {
          store.complete()
        }
        return
      }
      let tag = this.isTagActive.length ? this.isTagActive[0] : null
      try {
        let items = await this.loadPartnersWithTag(tag)
        if (items.length && store) {
          store.loaded()
        } else if (store) {
          store.complete()
        }
        return items
      } catch (e) {
        if (store) {
          store.error()
        }
        return []
      }
    },
    resetInfinity (tag) {
      this.from = 0;
      this.$store.dispatch('partners/onOrOffLoader', true)
      this.loadPartnersWithTag(tag).finally(() => {
        this.$store.dispatch('partners/onOrOffLoader', false)
      })
    },
    async loadPartnersWithTag (tag) {
      let include = config.partnersList.includes
      this.isLoad = true
      const categoryId = this.getActivePartnersCategory ? this.getActivePartnersCategory.entity_id : null
      return this.$store.dispatch('partners/loadPartners', { locationCode: this.currentLocation.code, categoryId, from: this.from, size: this.size, tag: tag, include: include }).then(res => {
        this.from += this.size
        return res.result
      })
        .finally(() => {
          this.isLoad = false
        })
    },
    widthBlockTags () {
      return document.getElementById('tags').offsetWidth
    },
    async changeTag () {
      this.showPartners = false
      this.from = 0
      if (this.$refs['partners-infinite']) {
        this.$refs['partners-infinite'].stateChanger.reset();
      }
      await this.loadPartners()
        .finally(() => {
          this.showPartners = true
        })
    }
  },
  watch: {
    tags: {
      handler () {
        this.openOrScrollTags()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.stores-cat {
  min-height: 330px;
}

.show-category-tags{
  @media (max-width: 1024px) {
    display: none;
  }
}
.dimming-element{
  height: 45px;
  width: 45px;
  position: absolute;
  right: 0;
  z-index: 1;
  background: #f9f8f6;
}
.block-three-doots{
  position: absolute;
  right: 0;
  z-index: 2;
  background-image: linear-gradient(to left, #f9f8f6 100%, rgba(249, 248, 246, 0.24) 0%);
  width: 105px;
  opacity: 0.9;
  height: 45px;
}
.three-dots{
  position: absolute;
  right: 0;
  color: #11bb2e;
  cursor: pointer;
  font-size: 35px;
  top: 8px;
}
.services {
  padding: 5px 0 8px 0;
}
.services {
  .left-block-info-store {
    padding-left: 0;
    padding-right: 6px;
  }
  .right-block-info-store {
    padding-right: 0;
    padding-left: 6px;
  }
}

.info-store {
  .left-info-block {
    display: flex;
    border-radius: 10px;
    background-color: #f9f8f6;
    padding: 10%;
    color: #11bb2e;
    font-size: 12px;
    .material-icons {
      margin: 0;
      padding-right: 4px;
      color: #11bb2e;
      font-size: 15px;
    }
  }

  .right-info-block {
    display: flex;
    border-radius: 10px;
    background-color: #f9f8f6;
    padding: 8%;
    color: #11bb2e;
    font-size: 12px;
    .wallet-icon {
      margin-right: 2px;
    }
  }
}

.container{
  .main{
    // Horizontal padding here double-counts .row's own -8px gutter-cancelling
    // margin (each .col-* card already re-adds its own 8px to land flush with
    // the parent edge) - pushed the whole grid an extra 8px right on desktop.
    // Mobile already had this correct (0 horizontal); matched here.
    padding: 16px 0;
  }
}
.stores-cat{
  background-color: #f9f8f6;
}
.categories-title {
  font-size: 36px;
}

.children a {
  font-weight: 100
}

.categories-wrapper {
  margin-top: -30px;
}

.cl-accent {
  @media (max-width: 555px) {
    font-size: 32px;
  }
}
.parent {
  width: 100%;
  height: 50px;
  overflow: hidden;
  .tags {
    white-space: nowrap;
    padding-bottom: 17px;
    box-sizing: content-box;
    @media (max-width: 1024px) {
      overflow-x: scroll;
      overflow-y: hidden;
    }

    &.current {
      .tag-wrap {
        display: none;

        &.active {
          display: inline-flex;
        }
      }
    }
  }
}
.tag-wrap{
  height: 35px;
  justify-content: center;
  border-radius: 35px;
  border:  1px solid #ebebeb;
  background-color: #ffffff;
  padding: 0 20px;
  font-size: 14px;
  font-family: "TTNorms Medium", sans-serif;
  &.active{
    background-color: #11bb2e;
    color: #fff;
    fill: #fff;

  }
  img{
    margin-left: 10px;
  }
  .material-icons.close{
    font-size: 21px;
    position: absolute;
    right: 0;
    top: -5px;
    color: #000;
    border-radius: 50%;
    background-color: #fff;
  }
}
</style>
